export default __webpack_public_path__ + "static/Foodservice-hero-44cdbe95d2a55f2f7e42a475c885b5d5.png";